import { render, staticRenderFns } from "./ThirdPartyPendenciesReport.vue?vue&type=template&id=f676dfac&scoped=true&"
import script from "./ThirdPartyPendenciesReport.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyPendenciesReport.vue?vue&type=script&lang=js&"
import style0 from "./ThirdPartyPendenciesReport.vue?vue&type=style&index=0&id=f676dfac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f676dfac",
  null
  
)

export default component.exports